import axios from 'axios';

export const searchConversations = async (
    studentId,
    resourceId,
    learningObjectId,
    subjectId
) => {
    const URL = `${process.env.REACT_APP_REPO}/v2/repo_aden/resources/conversations?student_id=${studentId}&resource_id=${resourceId}&learning_object_id=${learningObjectId}&subject_id=${subjectId}`;
    try {
        const response = await axios.get(URL);
        return response.data;
    } catch (error) {
        return { error };
    }
};

export const getConversationsResource = async (resourceId) => {
    const URL = `${process.env.REACT_APP_REPO}/v2/repo_aden/resources/${resourceId}/conversations/teachers`;

    try {
        const response = await axios.get(URL);
        return response.data;
    } catch (error) {
        return { error };
    }
};

export const getConversationResource = async (conversationId) => {
    const URL = `${process.env.REACT_APP_REPO}/v2/repo_aden/resources/conversations/${conversationId}`;
    try {
        const response = await axios.get(URL);
        return response.data;
    } catch (error) {
        return { error };
    }
};

export const getStudentConversationsResource = async (
    resourceId,
    subjectId
) => {
    const URL = `${process.env.REACT_APP_REPO}/v2/repo_aden/resources/${resourceId}/conversations/students${subjectId ? `?subject_id=${subjectId}` : ''}`;
    try {
        const response = await axios.get(URL);
        return response.data;
    } catch (error) {
        return { error };
    }
};

export const getStudentConversationResource = async (resourceId, subjectId) => {
    const URL = `${process.env.REACT_APP_REPO}/v2/repo_aden/resources/${resourceId}/conversations/students${subjectId ? `?subject_id=${subjectId}` : ''}`;
    try {
        const response = await axios.get(URL);
        return response.data;
    } catch (error) {
        return { error };
    }
};

export const postCommentResource = async (conversationId, body) => {
    const URL = `${process.env.REACT_APP_REPO}/v2/repo_aden/resources/conversations/${conversationId}/messages`;
    try {
        const response = await axios.post(URL, body);
        return response.data;
    } catch (error) {
        return { error };
    }
};

export const postCommentAndCreateConversationResource = async (
    resourceId,
    body
) => {
    const URL = `${process.env.REACT_APP_REPO}/v2/repo_aden/resources/${resourceId}/conversations`;
    try {
        const response = await axios.post(URL, body);
        return response.data;
    } catch (error) {
        return { error };
    }
};

export const editCommentResource = async (messageId, body) => {
    const URL = `${process.env.REACT_APP_REPO}/v2/repo_aden/resources/messages/${messageId}`;
    try {
        const response = await axios.patch(URL, body);
        return response.data;
    } catch (error) {
        return { error };
    }
};
